module.exports = __webpack_public_path__ + "static/media/add_stories.0c833316.svg";